import TabManager from './tab-manager'
import CurrentPeriodDataManager from "./current-period-data-manager";
import TransactionMap from "./transaction-map";
import UtilityFunctions from "./utility-functions";
import ChainDistributionChart from "./chain-distribution-chart";
import PollStatusManager from './poll-status-manager'

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Initialize tab management
  window.tabManager = new TabManager();

  // Initialize utility functions
  window.utilityFunctions = new UtilityFunctions();
  
  // Only initialize on savings summary show pages
  if (document.getElementById('current-transaction-map')) {
    window.transactionMap = new TransactionMap();
  }
  
  // Initialize chain distribution chart
  if (document.getElementById('current-chain-distribution-chart')) {
    window.chainDistributionChart = new ChainDistributionChart();
  }
  
  // Initialize current period data manager
  if (document.getElementById('current-main-content')) {
    window.currentPeriodDataManager = new CurrentPeriodDataManager();
  }
  
  // Set up legacy event listener for date range application
  const applyButton = document.getElementById('current-apply-date-range');
  if (applyButton) {
    applyButton.addEventListener('click', function() {
      if (window.currentPeriodDataManager) {
        window.currentPeriodDataManager.loadCurrentPeriodData();
      }
    });
  }


  window.pollStatusManager = new PollStatusManager('savings-summary-status', 'savings_summaries', '/savings_summaries/:id/status');
});
